import React, { useEffect, useState } from "react";
import { changeStatusBlockClient, changeStatusClient, deleteClient, getClients, getClientsByTherapistId } from "../../../../api/client";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Table, { buttonsStyle, dateFormatter } from "../../../components/tables/table";
import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import DeleteIcon from "@material-ui/icons/Delete";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Visibility } from "@material-ui/icons";
import { isOnlyTherapist } from "../../../../_metronic/_assets/js/components/user.utils";
import { getTherapeuticGroupsByTherapist } from "../../../../api/therapeuticGroup";

export default function ClientPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    const [clients, setClients] = useState([]);
    const [oldClients, setOldClients] = useState([]);
    const [client, setClient] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [block, setBlock] = useState("");
    const [refresh, setRefresh] = useState(false);

    const [therapeuticGroups, setTherapeuticGroups] = useState([]); //SOLO SI ES TERAPEUTA
    const readOnly = (!user?.isTherapist);

    useEffect(() => {
        setRefresh(false);
    }, [refresh])

    useEffect(() => {
        fetch();
    }, [])

    function fetch() {
        if (user?.isTherapist) {
            getTherapeuticGroupsByTherapist(user?._id)
                .then((res) => {
                    setTherapeuticGroups(res.data);
                })
                .catch((error) => {
                    if (error.request.status !== 404) {
                        alertError({
                            error,
                            customMessage: "Error al buscar los grupos terapéuticos."
                        })
                    }
                })
        }

        if (!readOnly) {
            getClientsByTherapistId(user?._id)
                .then((res) => {
                    let clients = [], oldClients = [];
                    for (let i = 0; i < res?.data?.length; ++i) {
                        const actC = res?.data[i];
                        if (!actC?.finalized) clients.push(actC);
                        else oldClients.push(actC);
                    }
                    console.log(clients, oldClients)
                    setClients(clients);
                    setOldClients(oldClients);
                })
                .catch((error) => {
                    if (error.request.status !== 404) {
                        alertError({
                            error,
                            customMessage: "No se ha podido encontrar los clientes."
                        })
                    }
                })
        }
        else {
            getClients()
                .then((res) => {
                    setClients(res.data);
                })
                .catch((error) => {
                    if (error.request.status !== 404) {
                        alertError({
                            error,
                            customMessage: "No se ha podido encontrar los clientes."
                        })
                    }
                })
        }
    }

    const columns = [
        { dataField: "fullName", text: "Nombre", sort: true,
            headerStyle: { width: '120px' } },
        { dataField: "surname", text: "Apellidos", sort: true,
            headerStyle: { width: '120px' } },
        { dataField: "phone", text: "Teléfono",
            headerStyle: { width: '81px' } },
        { dataField: "therapeuticGroup", text: "Grupo terapéutico", formatter: groupFormatter,
            headerStyle: { width: '120px' } },
        { dataField: "createdAt", text: "Fecha", formatter: dateFormatter, sort: true,
            headerStyle: { width: '110px' } },
        {
            dataField: "block1Done",
            text: "B1",
            formatter: (cell, row) => checkBoxFormatter("block1Done", cell, row),
            headerStyle: { width: "40px", textAlign: "center" },
            align: "center",
            headerAlign: "center"
        },
        {
            dataField: "block2Done",
            text: "B2",
            formatter: (cell, row) => checkBoxFormatter("block2Done", cell, row),
            headerStyle: { width: "40px", textAlign: "center" },
            align: "center",
            headerAlign: "center"
        },
        {
            dataField: "block3Done",
            text: "B3",
            formatter: (cell, row) => checkBoxFormatter("block3Done", cell, row),
            headerStyle: { width: "40px", textAlign: "center" },
            align: "center",
            headerAlign: "center"
        },
        {
            dataField: "extraDone",
            text: "E",
            formatter: (cell, row) => checkBoxFormatter("extraDone", cell, row),
            headerStyle: { width: "40px", textAlign: "center" },
            align: "center",
            headerAlign: "center"
        },
        user?.isAdmin && ({ 
            dataField: "finalized",
            text: "F",
            formatter: (cell, row) => checkBoxFormatter("finalized", cell, row),
            headerStyle: { width: "40px", textAlign: "center" },
            align: "center",
            headerAlign: "center"
        }),
        {
            dataField: "_id",
            text: "",
            align: 'right',
            formatter: buttonFormatter,
            headerStyle: { width: '150px' }
        },
    ].filter(Boolean);

    const finalizedColumns = [
        { dataField: "fullName", text: "Nombre", sort: true,
            headerStyle: { width: '120px' } },
        { dataField: "surname", text: "Apellidos", sort: true,
            headerStyle: { width: '120px' } },
        { dataField: "phone", text: "Teléfono",
            headerStyle: { width: '81px' } },
        { dataField: "therapeuticGroup", text: "Grupo terapéutico", formatter: groupFormatter,
            headerStyle: { width: '120px' } },
        { dataField: "createdAt", text: "Fecha", formatter: dateFormatter, sort: true,
            headerStyle: { width: '110px' } },
        {
            dataField: "_id",
            text: "",
            align: 'right',
            formatter: buttonFormatter,
            headerStyle: { width: '150px' }
        },
    ];
    

    function groupFormatter(cell) {
        if (!cell) return "";
        return cell?.fullName;
    }

    function checkBoxFormatter(block, cell, row) {
        const elem = clients.find((item) => item._id === row._id);

        let disabled = true, defDisable;
        switch (block) {
            case "block1Done" : break;
            case "block2Done" : if (!row?.block1Done) defDisable = true; break;
            case "block3Done" : if (!row?.block2Done) defDisable = true; break;
            case "extraDone" : if (!row?.block3Done) defDisable = true; break;
            case "finalized" : if (!row?.extraDone) defDisable = true; break;
        }

        if (!defDisable) {
            if (block === "finalized" || block === "extraDone") {
                if (user?.isAdmin) disabled = false;
            }
            else if (!readOnly) {
                let blockNum = null;
                switch (block) {
                    case "block1Done" : blockNum = "block1"; break;
                    case "block2Done" : blockNum = "block2"; break;
                    case "block3Done" : blockNum = "block3"; break;
                }
    
                const blockTherapist = elem?.therapeuticGroup[blockNum]?.therapist;
                if (blockTherapist === user?._id) disabled = false;
            }
        }

        return (
            <>
                <input type="checkbox" 
                    disabled={disabled}
                    checked={elem[block] || false}
                    onChange={() => { 
                        if (elem[block]) {
                            changeStatusBlockAux(elem, block);
                        }
                        else {
                            setOpenConfirmDialog(3);
                            setClient(elem);
                            setBlock(block);
                        }
                    }}
                />
            </>
        )
    }

    function changeStatusBlockAux(client, block) {
        const newState = !client[block];
        changeStatusBlockClient(client._id, block, newState)
            .then((res) => {
                if (res.status === 200) {
                    alertSuccess({ title: "Éxito!", customMessage: `Bloque ${newState ? "marcado" : "desmarcado"} correctamente.` })
                    fetch();
                    setRefresh(true);
                }
            })
            .catch((error) => {
                alertError({ error: error, customMessage: `No se ha podido cambiar el estado del bloque.` })
            });
    }

    function buttonFormatter(cell) {
        const elem = clients.find((item) => item._id === cell) || oldClients.find((item) => item._id === cell);

        if (readOnly || elem?.finalized) return (
        <>
            <Tooltip title="Ver">
            <Button
                style={buttonsStyle}
                size="small"
                onClick={() => history.push("/edit-client/" + elem._id)} // ?readonly=true
            >
                <Visibility />
            </Button>
            </Tooltip>
        </>)
        return (
        <>
            <Tooltip title="Edit">
            <Button
                style={buttonsStyle}
                size="small"
                onClick={() => history.push("/edit-client/" + elem._id)}
            >
                <EditIcon />
            </Button>
            </Tooltip>
            {user?.isAdmin && (
            <>
                <Tooltip title={elem?.active ? "Desactivar" : "Activar"}>
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                        setClient(elem);
                        setOpenConfirmDialog(1);
                    }}
                >
                    {elem?.active ? (
                    <ToggleOffIcon />
                    ) : (
                    <ToggleOnIcon style={{ color: "red" }} />
                    )}
                </Button>
                </Tooltip>
                <Tooltip title="Delete">
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                        setClient(elem);
                        setOpenConfirmDialog(2);
                    }}
                >
                    <DeleteIcon />
                </Button>
                </Tooltip>
            </>
            )}
        </>
        );
    }

    return  (
        <Card>
            <CardHeader title="Clientes">
                { user?.isTherapist && (
                    <CardHeaderToolbar>
                    <button
                        type="button"
                        className="btn btn-primary text-white"
                        onClick={() => {
                            if (user?.isTherapist && therapeuticGroups?.length === 0) {
                                let customMessage = "Para añadir nuevos clientes debes ser parte de algún grupo terapéutico.";
                                if (isOnlyTherapist(user)) customMessage += " Por favor, contacta con algún administrador.";
                                alertError({ error: null, customMessage })
                            }
                            else history.push("/edit-client")
                        }}
                    >
                        Añadir
                    </button>
                    </CardHeaderToolbar>
                )}
            </CardHeader>
            <CardBody>
                { !refresh && (
                    <>
                        <Table data={clients} columns={columns} />
                    </>
                )}
            </CardBody>
            {user?.isAdmin && (
                <>
                    <CardHeader title="Clientes archivados"></CardHeader>
                    <CardBody>
                        { !refresh && (
                            <>
                                <Table data={oldClients} columns={finalizedColumns} />
                            </>
                        )}
                    </CardBody>
                </>
            )}
            <ConfirmDialog
                title={`Seguro que quieres ${client?.active ? 'deshabilitar' : 'habilitar'} this client?`}
                open={openConfirmDialog === 1}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    changeStatusClient(client._id, !client?.active)
                        .then((res) => {
                            if (res.status === 200) {
                                alertSuccess({ title: `${client?.active ? 'Deshabilitado!' : 'Habilitado!'}`, customMessage: `Admin ${client?.active ? 'deshabilitado' : 'habilitado'} correctamente` })
                                fetch();
                                setRefresh(true);
                            }
                        })
                        .catch((error) => {
                            alertError({ error: error, customMessage: `Could not ${client?.active ? 'deshabilitar' : 'habilitar'} admin.` })
                        });
                }}
            />
            <ConfirmDialog
                title={'Seguro que quieres eliminar el cliente?'}
                open={openConfirmDialog === 2}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    deleteClient(client?._id)
                        .then((res) => {
                            if (res.status === 204 || res.status === 200) {
                                alertSuccess({
                                    title: 'Eliminado!',
                                    customMessage: 'Client eliminado correctamente.',
                                });
                                fetch();
                                setRefresh(true);
                            }
                        })
                        .catch((error) => {
                            alertError({
                                error: error,
                                customMessage: 'No se ha podido eliminar el client.',
                            });
                        });
                }}
            />
            <ConfirmDialog
                title={`Seguro que quieres finalizar el bloque? Se enviará un mail informando el usuario.`}
                open={openConfirmDialog === 3}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    changeStatusBlockAux(client, block);
                }}
            />
        </Card>
    )
} 